import React, { useState } from 'react';
import { useProfile, useShares } from '../../components/state/hooks';
import { updateTasksViewedCount, updateMarkingTemplatesViewedCount, updateCommentBanksViewedCount, updateShortAnswersViewedCount, updateSuccessCriteriaViewedCount, updateSuccessCriteriasViewedCount } from '../../service';
import Loader from '../../components/Loader';
import {
  BannerContainer,
  BannerContent,
  LeftSection,
  RightSection,
  SharedWithMeIcon,
  SharedWithMeLinkText,
  ViewText,
  CountInParentheses,
  CloseButton,
  CloseIcon,
} from './style';
import sharedIcon from '../../static/img/24grayshare.svg';
import closeIcon from '../../static/img/closecircle.svg';

const SharedWithMeLink = ({ resourceTypes, link }) => {
  const { data: profile, isLoadingdata: isLoadingProfile, resetData: resetProfile } = useProfile();
  const { data: tasksShares } = useShares('TASK');
  const { data: allShares } = useShares(null);
  const [isDismissed, setIsDismissed] = useState(false);
  
  if (isLoadingProfile) {
    return <Loader />;
  }
  
  const countUnviewedShares = (shares, lastViewedTimestamp) => {
    if (!Array.isArray(shares)) return 0;
    if (!lastViewedTimestamp) return shares.length;
    
    const lastViewedDate = new Date(lastViewedTimestamp);
    return shares.filter((share) => {
      const resource = share.resource;
      const sharedOn = resource?.sharedOn;
      if (!sharedOn) return false;
      const sharedOnDate = new Date(sharedOn);
      return sharedOnDate > lastViewedDate;
    }).length;
  };
  
  const markingTemplateShares = Array.isArray(allShares) ? allShares.filter((share) => {
    const resource = share.resource;
    const resourceType = resource?.itemType;
    return resourceType === 'MARKING_TEMPLATE';
  }) : [];
  
  const commentBankShares = Array.isArray(allShares) ? allShares.filter((share) => {
    const resource = share.resource;
    const resourceType = resource?.itemType;
    return resourceType === 'COMMENT_BANK' || resourceType === 'COMMENT_BANKS';
  }) : [];

  const shortAnswerShares = Array.isArray(allShares) ? allShares.filter((share) => {
    const resource = share.resource;
    const resourceType = resource?.itemType;
    return resourceType === 'SHORT_ANSWERS';
  }) : [];

  const successCriteriaShares = Array.isArray(allShares) ? allShares.filter((share) => {
    const resource = share.resource;
    const resourceType = resource?.itemType;
    return resourceType === 'SUCCESS_CRITERIA';
  }) : [];

  const count = resourceTypes?.reduce((total, type) => {
    if (type === 'TASK') {
      return total + countUnviewedShares(Array.isArray(tasksShares) ? tasksShares : [], profile?.lastViewedTimestamps?.tasks);
    }
    if (type === 'MARKING_TEMPLATE') {
      return total + countUnviewedShares(markingTemplateShares, profile?.lastViewedTimestamps?.markingCriterias);
    }
    if (type === 'COMMENT_BANK') {
      return total + countUnviewedShares(commentBankShares, profile?.lastViewedTimestamps?.commentbanks);
    }
    if (type === 'SHORT_ANSWERS') {
      return total + countUnviewedShares(shortAnswerShares, profile?.lastViewedTimestamps?.shortAnswers);
    }
    if (type === 'SUCCESS_CRITERIA') {
      return total + countUnviewedShares(successCriteriaShares, profile?.lastViewedTimestamps?.successCriteria);
    }
    if (type === 'SUCCESS_CRITERIA') {
      return total + countUnviewedShares(successCriteriaShares, profile?.lastViewedTimestamps?.successCriterias);
    }
    return total;
  }, 0) || 0;

  if (count === 0 || isDismissed) {
    return null;
  }

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDismissed(true);
  };

  const handleClick = async (e) => {
    try {
      if (resourceTypes?.includes('TASK')) {
        await updateTasksViewedCount();
      }
      if (resourceTypes?.includes('MARKING_TEMPLATE')) {
        await updateMarkingTemplatesViewedCount();
      }
      if (resourceTypes?.includes('COMMENT_BANK')) {
        await updateCommentBanksViewedCount();
      }
      if (resourceTypes?.includes('SHORT_ANSWERS')) {
        await updateShortAnswersViewedCount();
      }
      if (resourceTypes?.includes('SUCCESS_CRITERIA')) {
        await updateSuccessCriteriaViewedCount();
      }
      if (resourceTypes?.includes('SUCCESS_CRITERIA')) {
        await updateSuccessCriteriasViewedCount();
      }

      resetProfile();
    } catch (error) {
      console.error('Error updating viewed count:', error);
    }
      
    if (link) {
      window.location.href = link;
    }
  };

  return (
    <BannerContainer onClick={handleClick}>
      <BannerContent>
        <LeftSection>
          <SharedWithMeIcon src={sharedIcon} alt="Shared with me" />
          <SharedWithMeLinkText>Shared with me</SharedWithMeLinkText>
          <ViewText>
            View <CountInParentheses>({count})</CountInParentheses>
          </ViewText>
        </LeftSection>
        <RightSection>
          <CloseButton onClick={handleClose} type="button">
            <CloseIcon src={closeIcon} alt="Close" />
          </CloseButton>
        </RightSection>
      </BannerContent>
    </BannerContainer>
  );
};

export default SharedWithMeLink;

